import { PersonalInfo } from "./PersonalInfo";
import { WorkHistory } from "./WorkHistory";
import { SelfPR } from "./SelfPR";
import { PersonalDevelopment } from "./PersonalDevelopment";
import type { CVData } from "../types/cv";

interface CVDisplayProps {
  cvData: CVData;
}

export function CVDisplay({ cvData }: CVDisplayProps) {
  return (
    <div className="min-h-screen w-full">
      <div className="max-w-5xl mx-auto px-4 pt-14 pb-28 sm:px-6 sm:pt-20 sm:pb-36 print:p-0">
        <div className="flex flex-col gap-20 print:gap-12">
          <PersonalInfo personal_info={cvData.personal_info} />
          <SelfPR self_pr={cvData.self_pr} />
          <WorkHistory history={cvData.history} />
          <PersonalDevelopment
            personal_development={cvData.personal_development}
          />
        </div>
      </div>
    </div>
  );
}
